import { Injectable } from "@angular/core";
import { IntentOptions, WebIntent } from "@ionic-native/web-intent/ngx";
import { CLEVER_TAP_EVENT } from "src/app/core/constants/clever-tab-event-constants";
import { upiAppClicked } from "../utils/clever-tab-functions";
import { AnalyticsService } from "./analytics.service";

@Injectable({ providedIn: 'root' })
export class WebIntentService {

  constructor(private webIntent: WebIntent, private analyticsService: AnalyticsService) { }

  //   intent.setClassName("in.org.npci.upiapp","in.org.npci.upiapp.HomeActivity");
  // startActivityForResult(intent,1);
  openUrl(url) {
    const options: IntentOptions = {
      action: this.webIntent.ACTION_VIEW,
      url: url,
    }
    // if (url.indexOf('upi') == 0) {
    //   options.component = {
    //     class: 'in.org.npci.upiapp.HomeActivity',
    //     package: 'in.org.npci.upiapp'
    //   }
    // }
    this.webIntent.startActivity(options).then((onSuccess) => {
      console.log("Success:", onSuccess)
      // alert(onSuccess.extras.resultCode)
      // alert(onSuccess.flag)
    }, (onError) => {
      console.log("Error:", onError)
    });
  }

  openAllUpiUrl(url){
    const options: IntentOptions = {
      action: this.webIntent.ACTION_VIEW,
      url: url,
      requestCode: 123
    }
    // if (url.indexOf('upi') == 0) {
    //   options.component = {
    //     class: 'in.org.npci.upiapp.HomeActivity',
    //     package: 'in.org.npci.upiapp'
    //   }
    // }
    return this.webIntent.startActivityForResult(options)
  }

  async openUPIApp(url, packageName) {
    const options: IntentOptions = {
      action: this.webIntent.ACTION_VIEW,
      url: url,
      package: packageName,
      requestCode: 123
    }
    // this.webIntent.startActivityForResult(options).then((onSuccess) => {
    //   console.log("Success:", onSuccess)
    //   this.analyticsService.cleverTapEvent(CLEVER_TAP_EVENT.UPI_APP_CLICKED, upiAppClicked({ url, packageName, status: onSuccess }));
    // }, (onError) => {
    //   console.log("Error:", onError)
    //   this.analyticsService.cleverTapEvent(CLEVER_TAP_EVENT.UPI_APP_CLICKED, upiAppClicked({ url, packageName, status: onError }));
    // }).catch((error) => {
    //   console.log("Error 1:", error)
    // });
    return this.webIntent.startActivityForResult(options);

  }

}